import type { GlobalFilter } from '@webapp/account/src/resources/reports/global-filters';

export enum TaskStatus {
    CREATED = 1,
    STARTED = 2,
    PROCESSED = 3,
    CANCELED = 5,
    PAUSED = 6,
    ERROR = 7,
    REPEAT = 8,
    FORCE_RUN = 9,
    COMPLETED = 10,
}

export enum FileType {
    PDF = 1,
    CSV = 2,
    SPSS = 3,
    XLSX = 4,
    XLSX_DIA = 5,
}

export enum TaskType {
    ARCH = 'ARCH',
    RSLT = 'RSLT',
    RESP = 'RESP',
    PDF = 'PDF',
    ASPS = 'ASPS',
}

export const TASK_STATUS_FAIL = [TaskStatus.CANCELED, TaskStatus.ERROR];

export const TASK_STATUS_SUCCESS = [TaskStatus.COMPLETED, TaskStatus.FORCE_RUN];

export enum TaskLocalStatus {
    LOADING = 'loading',
    COMPLETED = 'completed',
    ERROR = 'error',
}

export enum SubtaskStatus {
    CREATED = 'CREATED',
    WAITING = 'WAITING',
    GET_FILES_INFO = 'GET_FILES_INFO',
    GET_FILES_FROM_S3 = 'GET_FILES_FROM_S3',
    SAVE_FILES_IN_ARCHIVE = 'SAVE_FILES_IN_ARCHIVE',
    SAVE_ARCHIVE_IN_S3 = 'SAVE_ARCHIVE_IN_S3',
    COMPLETE = 'COMPLETE',
}

export interface Task {
    id?: number;
    uuid: string;
    created: number;
    results: AnyObject;
    systemStatus?: TaskStatus;
    status: TaskLocalStatus;
    type: TaskType;
    position?: number;
    total?: number;
}

export interface TaskResponseItem {
    ID: number;
    TYPE: TaskType;
    RESULTS: any;
    PARAMETERS: any;
    STATUS: TaskStatus;
    POSITION: number;
    TOTAL: number;
}

export type TaskCreateProps = {
    uuid: string;
    audio?: boolean;
    surveyId?: number;
    taskType: TaskType;
    fileType: FileType;
    questions?: Array<number>;
    globalFilters: GlobalFilter;
    params?: AnyObject;
    onlyTestScore?: boolean;
    pageScores?: boolean;
    linkId?: string;
    lang?: string;
};
